export function getMetadataValue({
    metaDataItem,
    itemValue,
}: {
    metaDataItem?:
        | {
              name: string;
              control: string;
              options?: {
                  value: string;
                  text: string;
              }[];
          }
        | undefined;
    itemValue: string;
}) {
    if (!metaDataItem) {
        return itemValue;
    }
    if (metaDataItem.control === 'textarea') {
        return itemValue;
    } else if (metaDataItem.control === 'dropdown' && metaDataItem.options) {
        const selectedOption = metaDataItem.options.find((i) => i.value === itemValue);
        if (selectedOption) {
            return selectedOption.text;
        }
        return itemValue;
    }
    return itemValue;
}
